'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('whatwg-fetch');

require('es6-promise/auto');

var _themeCart = require('../../state/themeCart/theme-cart');

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCart = function getCart() {
  return $.getJSON('/cart.json', function (cart) {
    return cart;
  });
}; /* eslint-disable camelcase */


var updateCartCount = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
    var cartState;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _Flow2.default.isReady();

          case 2:
            cartState = _state2.default.get('cart');


            $(_Dom2.default.cartItemCount).text(cartState.item_count);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function updateCartCount(_x) {
    return _ref.apply(this, arguments);
  };
}();

var addToCart = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data) {
    var _ts, type, action, _variantId, quantity, properties, _data, variantId, requestData, responseData;

    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // console.log('==== add to cart data', data);
            _ts = Date.now();
            type = 'cart';
            action = 'add';
            _variantId = data.variantId, quantity = data.quantity, properties = data.properties, _data = (0, _objectWithoutProperties3.default)(data, ['variantId', 'quantity', 'properties']);
            variantId = parseInt(_variantId);
            requestData = { type: type, action: action, variantId: variantId, quantity: quantity, properties: properties, _data: _data, _ts: _ts };
            _context2.prev = 6;

            PubSub.publish(_Constants2.default.enqueueRequest, [requestData]);

            // console.log('=== here before addItem');

            _context2.next = 10;
            return (0, _themeCart.addItem)(variantId, { quantity: quantity, properties: properties }).then(function (data) {
              console.log('==== addItem then response data', data);
            });

          case 10:
            responseData = _context2.sent;


            // console.log('==== after addItem', responseData);

            PubSub.publish(_Constants2.default.requestSuccess, { requestData: requestData, responseData: responseData });
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2['catch'](6);

            // console.log('addToCart error', error);
            PubSub.publish(_Constants2.default.requestError, { error: _context2.t0, data: requestData });

          case 17:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[6, 14]]);
  }));

  return function addToCart(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var removeFromCart = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(data) {
    var _ts, type, action, key, _data, requestData, shopifyCart;

    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ts = Date.now();
            type = 'cart';
            action = 'remove';
            key = data.key, _data = (0, _objectWithoutProperties3.default)(data, ['key']);
            requestData = Object.assign({ type: type, action: action, key: key }, _data, { _ts: _ts });
            _context3.prev = 5;

            PubSub.publish(_Constants2.default.enqueueRequest, [requestData]);

            _context3.next = 9;
            return getCart();

          case 9:
            shopifyCart = _context3.sent;
            _context3.next = 12;
            return (0, _themeCart.removeItem)(key).then(function (responseData) {

              PubSub.publish(_Constants2.default.requestSuccess, { requestData: requestData, responseData: responseData });
            });

          case 12:
            _context3.next = 17;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3['catch'](5);

            // console.log('removeFromCart error', error);
            PubSub.publish(_Constants2.default.requestError, { error: _context3.t0, data: requestData });

          case 17:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[5, 14]]);
  }));

  return function removeFromCart(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var updateCart = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(data) {
    var _ts, type, action, key, _quantity, properties, _data, quantity, requestData, klarna, responseData, totalPrice;

    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ts = Date.now();
            type = 'cart';
            action = 'update';
            key = data.key, _quantity = data.quantity, properties = data.properties, _data = (0, _objectWithoutProperties3.default)(data, ['key', 'quantity', 'properties']);
            quantity = parseInt(_quantity);
            requestData = Object.assign({ type: type, action: action, key: key }, _data, { _ts: _ts });
            klarna = _state2.default.get('klarna');


            if (quantity && !isNaN(quantity)) {
              requestData.quantity = quantity;
            }

            if (properties && (typeof properties === 'undefined' ? 'undefined' : (0, _typeof3.default)(properties)) === 'object') {
              requestData.properties = properties;
            }

            _context4.prev = 9;

            PubSub.publish(_Constants2.default.enqueueRequest, [requestData]);

            _context4.next = 13;
            return (0, _themeCart.updateItem)(key, Object.assign({}, requestData));

          case 13:
            responseData = _context4.sent;
            totalPrice = responseData.total_price;


            if (klarna.active) {
              $('.extra-cart-info klarna-placement').attr('data-purchase_amount', totalPrice);

              window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
              window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
            }

            PubSub.publish(_Constants2.default.requestSuccess, { requestData: requestData, responseData: responseData });
            _context4.next = 22;
            break;

          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4['catch'](9);

            PubSub.publish(_Constants2.default.requestError, { error: _context4.t0, data: requestData });

          case 22:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[9, 19]]);
  }));

  return function updateCart(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

var batchProcessRequests = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(requests) {
    var type, action, methods, _requests, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, request;

    return _regenerator2.default.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            type = 'cart';
            action = 'batch';
            methods = { addItem: _themeCart.addItem, removeItem: _themeCart.removeItem, updateItem: _themeCart.updateItem };
            _requests = requests.map(function (request) {
              var _ts = Date.now();
              var requestData = Object.assign({ type: type, action: action }, request, { _ts: _ts });

              PubSub.publish(_Constants2.default.enqueueRequest, [requestData]);

              return Object.assign({}, request, { _ts: _ts });
            });
            _context6.prev = 4;
            _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop(request) {
              var requestData, cartMethod;
              return _regenerator2.default.wrap(function _loop$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      requestData = Object.assign({ type: type, action: action }, request);
                      cartMethod = methods[request.method];
                      _context5.next = 4;
                      return cartMethod.apply(undefined, (0, _toConsumableArray3.default)(request.args)).then(function (responseData) {
                        // console.log('=== batch req data', responseData);

                        setTimeout(function () {
                          return PubSub.publish(_Constants2.default.requestSuccess, { requestData: requestData, responseData: responseData });
                        }, 1000);
                      }).catch(function (error) {
                        // console.log('=== batch req err', error);

                        PubSub.publish(_Constants2.default.requestError, { error: error, data: requests });
                      });

                    case 4:
                    case 'end':
                      return _context5.stop();
                  }
                }
              }, _loop, undefined);
            });
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context6.prev = 9;
            _iterator = _requests[Symbol.iterator]();

          case 11:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context6.next = 17;
              break;
            }

            request = _step.value;
            return _context6.delegateYield(_loop(request), 't0', 14);

          case 14:
            _iteratorNormalCompletion = true;
            _context6.next = 11;
            break;

          case 17:
            _context6.next = 23;
            break;

          case 19:
            _context6.prev = 19;
            _context6.t1 = _context6['catch'](9);
            _didIteratorError = true;
            _iteratorError = _context6.t1;

          case 23:
            _context6.prev = 23;
            _context6.prev = 24;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 26:
            _context6.prev = 26;

            if (!_didIteratorError) {
              _context6.next = 29;
              break;
            }

            throw _iteratorError;

          case 29:
            return _context6.finish(26);

          case 30:
            return _context6.finish(23);

          case 31:
            _context6.next = 36;
            break;

          case 33:
            _context6.prev = 33;
            _context6.t2 = _context6['catch'](4);

            // console.log('=== batch req catch', error);
            PubSub.publish(_Constants2.default.requestError, { error: _context6.t2, data: requests });

          case 36:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee5, undefined, [[4, 33], [9, 19, 23, 31], [24,, 26, 30]]);
  }));

  return function batchProcessRequests(_x5) {
    return _ref5.apply(this, arguments);
  };
}();

var init = exports.init = function init(data) {};

exports.default = {
  init: init,
  add: addToCart,
  update: updateCart,
  remove: removeFromCart,
  batch: batchProcessRequests,
  updateCartCount: updateCartCount
};